<i18n>
{
	"en": {
		"missingEtd": "Etd",
		"missingDespatchParty": "Despatch party",
		"missingDeliveryParty": "Delivery party",
		"missingGoodsType": "Goods type",
		"missingOrderType": "Order type",
		"missingFreightWeight": "Freight weight",
		"validationErrors": "Validation errors"
	},
	"no": {
		"missingEtd": "Etd",
		"missingDespatchParty": "Henteadresse",
		"missingDeliveryParty": "Leveringsadresse",
		"missingGoodsType": "Godstype",
		"missingOrderType": "Ordretype",
		"missingFreightWeight": "Fraktberegningsvekt",
		"validationErrors": "Valideringsfeil",
		"orderNumber": "Oppdragsnummer"
	}
}
</i18n>
<template>
	<t-grid
		ref="validationResultBeforeEdiGrid"
		:key="'validationResultBeforeEdiGrid'"
		:columnDefinitions="columnDefinitions"
		:defaultColumnDefinition="defaultColumnDefinition"
		:rowHeight="50"
		:showFilters="false"
		:items="orderValidationResults"
	/>
</template>

<script>
export default {

	props: {
		orderValidationResults : Array
	},
	data() {
		return {
			columnDefinitions: [
				{
					field: 'order.orderNumber',
					displayName: this.$t('orderNumber'),
					resizable: true,
				},
				{
					field: 'validationErrors',
					valueGetter: (item) => item.validationErrors.map(y => this.$t(y)).join(', '),
					displayName: this.$t('validationErrors'),
					resizable: true,
				},
			],
			defaultColumnDefinition: { resizable: true }
		};
	},
};
</script>

<style>

</style>